import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Abstracts
import { NgRefreshService } from '../abstracts';

@Injectable()
export class RefreshService implements NgRefreshService {

    private source = new BehaviorSubject<boolean>(false);
    public status = this.source.asObservable();

    public refresh() {
        this.source.next(true);
        this.source.next(false);
    }

}
